/**
 *  Данная утилита служит для присвоения данных из relationships в переменную.
 *
 *  Функция принимает 3 параметра:
 *  props - массив свойств которые нас интересуют
 *  shape - в случае отсутствия данных у топика, мы можем назначить нужный вид
 *  defaultValue - если данных нет и шейп не задан на помощь приходит дефолтное значение
 *
 *  Пример:
 *
 *  const shape = {
 *    image: {
 *      caption: null,
 *      credits: null,
 *      versions: {},
 *    },
 *    tags: [],
 *  };
 *
 *  const relationships = resolveRelationships(['image', 'tags'], {}, shape);
 *
 *  const {
 *    image,
 *  } = relationships(topicContent);
 */

/** TODO: REF
 * Написать отдельную утилиту на основе этой,
 * которая будет резолвить данные на основе обязательных свойств моделей из свагера.
 */

export default function resolveRelationships(props, defaultValue, shape) {
  return content => props.reduce((result, name) => {
    // Быстрый траверсинг по заранее известной структуре данных.

    if (content
      && content.relationships
      && content.relationships[name]
      && content.relationships[name].data) {
      if (Array.isArray(content.relationships[name].data)) {
        result[name] = content.relationships[name].data;
      } else {
        result[name] = content.relationships[name].data.attributes;
      }
    } else if (shape && shape[name]) {
      result[name] = shape[name];
    } else {
      result[name] = defaultValue;
    }

    return result;
  }, {});
}
